<template>
  <transition name="slide-fade">
    <div class="warning-toast" :style="{ borderLeft: '0.25rem solid #E65447' }">
      <div class="warning-toast__icon">
        <i class="fas fa-exclamation-circle"></i>
      </div>

      <div class="flex min-w-0 flex-1 flex-col">
        <p class="mb-1 text-[1.1em] font-bold">
          {{ title }}
        </p>

        <p v-if="description" class="text-sm leading-5 text-white/90">
          {{ description }}
        </p>
        <div class="warning-toast__actions">
        <button
          class="warning-toast__action"
          data-entity="producer-warningReload"
          data-test="warning-toast"
          @click="onClickSaveAndReload"
        >
          Save &amp; Reload
        </button>

        <button
          class="warning-toast__action"
          data-entity="producer-warningReload"
          data-test="warning-toast"
          @click="onClickReload"
        >
          Reload
        </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      default: '',
    },
  },

  methods: {
    ...mapActions(['saveProduction']),

    onClickSaveAndReload() {
      this.saveProduction().then(() => {
        // Short delay so user sees the save success toast before the reload.
        setTimeout(() => { window.location.reload(); }, 500);
      });
    },

    onClickReload() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.warning-toast {
  position: fixed;
  right: 1rem;
  bottom: calc(0.5rem + 40px);
  z-index: 10000;
  display: flex;
  max-width: 28rem;
  padding: 1rem 2rem;
  border-radius: 0.25rem;
  color: #fff;
  background-color: var(--tgb-slate-toast, #1f1f1f);
  box-shadow:
    0 0.1875rem 0.25rem rgba(0, 0, 0, 0.14),
    0 0.1875rem 0.1875rem -0.125rem rgba(0, 0, 0, 0.12),
    0 0.0625rem 0.5rem rgba(0, 0, 0, 0.2);
}

.warning-toast__icon {
  margin-right: 1rem;
  font-size: 2rem;
  line-height: 1.25;
}

.warning-toast__action {
  cursor: pointer;
  white-space: nowrap;
  border: 0;
  border-radius: 0.25rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  background-color: var(--tgb-btn-primary, #2bacca);
  transition: background-color 0.2s ease, outline-color 0.2s ease;

  &:hover {
    background-color: var(--tgb-btn-primary-hover, #23cdf4);
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
}

.warning-toast__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.75rem;
}
</style>
